import VideoJsAdapter from '../../adapters/videojs_adapter';
import Component from '../component.js';
import { PlayerAhoyEvent } from '../../player_ahoy_event';

export default class SkipIntroButton extends Component {
  constructor(player, options = {}) {
    super(player, options);
    this._chaptersIntroStart = options.chaptersIntroStart;
    this._chaptersIntroEnd = options.chaptersIntroEnd;
    this.playUUID= options.playUUID;
    this.videoId = options.videoId;
  }

  createEl() {
    const el = super.createEl('button', {
      className: 'vp-skip-intro-button vp-skip-intro-button--hidden',
      innerHTML: 'Skip Intro',
      type: 'button',
      title: 'Skip Intro'
    });
    el.addEventListener('click', this.onButtonClick.bind(this))
    return el;
  }

  ready() {
    this.player().on('timeupdate', this.onTimeUpdate.bind(this));
    this.player().on('userinactive', this.onUserInactive.bind(this));
    this.player().on('useractive', this.onUserActive.bind(this));
  }

  onTimeUpdate() {
    if (this.shouldShowButton()) {
      this.show();
    } else {
      this.hide();
    }
  }

  shouldShowButton() {
    return (this._chaptersIntroStart <= this.currentTime() && this.currentTime() < this._chaptersIntroEnd)
  }

  show() {
    if (this.el().classList.contains('vp-skip-intro-button--hidden')) {
      this.el().disabled = false;
      this.el().classList.remove('vp-skip-intro-button--hidden');
      this.sendEvent({ action: 'impression' })
    }
  }

  hide() {
    this.el().classList.add('vp-skip-intro-button--hidden');
  }

  currentTime() {
    return Math.floor(this.player().currentTime());
  }

  onButtonClick() {
    this.el().disabled = true;
    this.player().currentTime(this._chaptersIntroEnd);
    this.sendEvent({ action: 'click' })
  }

  onUserInactive() {
    if (!this.player().paused()) {
      this.el().classList.add('vp-skip-intro-button--move-down');
    }
  }

  onUserActive() {
    this.el().classList.remove('vp-skip-intro-button--move-down');
  }

  sendEvent({ action }) {
    PlayerAhoyEvent.sendSkipIntro(action, this.videoId, this.playUUID)
  }
}

VideoJsAdapter.registerComponent('VpSkipIntroButton', SkipIntroButton);